import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // For navigation after successful signup

const Signup = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(''); // To display success/error message

  const navigate = useNavigate(); // For navigation to other pages

  const handleSignup = async () => {
    try {
      const response = await axios.post('https://upload.hariombusinessenterprise.com/signup.php', {
        firstName,
        lastName,
        username,
        email,
        password
      });
      
      if (response.data.status === 'success') {
        // If signup is successful, show a success message and navigate to the login page
        setMessage('Signup successful! You can now login.');
        setTimeout(() => {
          navigate('/login'); // Navigate to the login page after a few seconds
        }, 2000);
      } else {
        // If signup failed, show an error message
        setMessage(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error signing up:", error);
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div>
      <h2>Signup</h2>
      <input type="text" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)} />
      <input type="text" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)} />
      <input type="text" placeholder="Username" onChange={(e) => setUsername(e.target.value)} />
      <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
      <input type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleSignup}>Signup</button>

      {message && <p>{message}</p>} {/* Display success or error message */}
    </div>
  );
};

export default Signup;
